(function () {
    'use strict';

    angular.module('app.checklists', [
        'app.core',
        'app.widgets'
    ]);
})();
